<template>
    <div class="review-total-score-box" v-if="review_count">
        <h3 class="review-title">
            Reinerie Hypotheken<br>
            <span class="review-subtitle">
                is beoordeeld met een {{ review_count.Score }}
            </span>
        </h3>
        <p class="review-text">
            Bij Reinerie Hypotheken staan jouw wensen altijd voorop. Daarom worden we door onze klanten beoordeeld met een {{ review_count.Score }}. Benieuwd waarom?
        </p>
        <div class="total-score-box" itemprop="aggregateRating" itemscope="" itemtype="http://schema.org/AggregateRating">
            <meta itemprop="ratingValue" :content="review_count.Score">
            <meta itemprop="worstRating" content="1">
            <meta itemprop="bestRating" content="10">
            <meta itemprop="reviewCount" :content="review_count.ReviewCount">
        </div>
    </div>
</template>

<script>
const axios = require('axios');
export default {
    name: 'ReviewScore',
    data() {
        return {
            review_count: null,
            reviews: null,
        }
    },
    methods: {
        getReviews() {
            axios.get(`https://api.advieskeuze.nl/feed/reviews/c2b3708e-4a10-458b-af42-48639140637e?json=true`)
                .then(({data}) => {
                    this.review_count = data.ReviewCount;
                    this.reviews = data.Reviews;
                });
        },
    },
    created () {
        this.getReviews();
    },
}
</script>

<style lang="scss" scoped>
    .review-total-score-box {
        .review-title {
            font-family: 'Bree Serif',Georgia,'Times New Roman',serif;
            color:#fff;
            font-size: 30px;
            font-weight: 300;
            line-height: 1em;
            text-shadow: 1px 1px 4px rgba(0,0,0,.35);
            margin-top: 0;

            @media (max-width: 425px) {
                line-height: 1.5em;
            }

            .review-subtitle {
                font-family: 'Saira Condensed',Helvetica,Arial,Lucida,sans-serif;
                text-transform: uppercase;
                font-size: 40px;
                font-weight: bold;
                line-height: 1.7em;

                @media (max-width: 425px) {
                    font-size: 32px;
                    line-height: 1.2em;
                }
            }
        }

        .review-text {
            color:#fff;
            line-height: 40px;
            font-size: 20px;

            @media (max-width: 425px) {
                line-height: 34px;
                font-size: 18px;
            }
        }
    }
</style>